import { useMutation, useQueryClient } from '@tanstack/react-query';
import apiClient from '../services/api';

export const useUpdateZonesBulk = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ 
      zoneIds, 
      updates 
    }: { 
      zoneIds: string[]; 
      updates: Partial<{
        theme: string;
        type: string;
        nombreEtagere: number;
      }> 
    }) => {
      const response = await apiClient.patch('/zones/bulk/update', { zoneIds, updates });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['zones'] });
    },
  });
};

export const useDeleteZonesBulk = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (zoneIds: string[]) => {
      const response = await apiClient.delete('/zones/bulk/delete', { data: { zoneIds } });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['zones'] });
      queryClient.invalidateQueries({ queryKey: ['objets'] });
    },
  });
};

